module.exports = __webpack_public_path__ + "img/3_pfw.ea406f9d.jpg";